import { Field } from "formik";
import { TextField } from "formik-mui";
import Mark from "../../../assets/svg/mark.svg";

const Form1 = ({ values }) => {

  return (
    <>
      <p className="text-[#131221] font-black text-[16px] md:text-[24px] self-start w-[252px] mt-10">Please Complete Your Profile</p>
      <div className="w-full flex flex-col items-center justify-center ">
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"address"}
              label="Your Mailing Address"
              value={values.address || ""}
              placeholder="312 Quilly Lane Worthington"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"zipCode"}
              label="Zip Code"
              value={values.zipCode || '' }
              placeholder="1234567"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>{" "}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"city"}
              label="City"
              placeholder="City"
              value={values.city || ''}
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>{" "}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"state"}
              label="State"
              value={values.state || ''}
              placeholder="New York"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>{" "}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"country"}
              label="Country"
              value={values.country || ''}
              placeholder="USA"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form1;
